import vue from "vue";
import CustomInput from "./views/components/customInput.vue";
import customSelect from "./views/components/customSelect.vue";
import multipleSelect from "./views/components/multipleSelect.vue";
import initialLoader from "./views/components/initialLoader.vue";
import accessNotAllowed from "./views/components/accessNotAllowed.vue";
import advanceSearchSelect from "./views/components/advanceSearchSelect.vue";
import itemsSelect from "./views/components/itemsSelect.vue";


vue.component("custom-input", CustomInput);
vue.component("custom-select", customSelect);
vue.component("advance-search-select", advanceSearchSelect);
vue.component("multiple-select", multipleSelect);
vue.component("initial-loader", initialLoader);
vue.component("access-not-allowed", accessNotAllowed);
vue.component("items-select", itemsSelect);